import { render, staticRenderFns } from "./CostDetails.vue?vue&type=template&id=5a17ddaf&scoped=true&"
import script from "./CostDetails.vue?vue&type=script&lang=js&"
export * from "./CostDetails.vue?vue&type=script&lang=js&"
import style0 from "./CostDetails.vue?vue&type=style&index=0&id=5a17ddaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a17ddaf",
  null
  
)

export default component.exports